import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

export const useContactFormSchema = () => {
    const { t } = useTranslation();

    return Yup.object().shape({
        eventType: Yup.string().required(
            t('contactForm.errorMsgRequiredField')
        ),
        date: Yup.string().required(t('contactForm.errorMsgRequiredField')),
        addServices: Yup.array().required(
            t('contactForm.errorMsgRequiredField')
        ),
        email: Yup.string()
            .email()
            .required(t('contactForm.errorMsgRequiredField')),
        agreementToProcessPD: Yup.string()
            .min(2)
            .required(t('contactForm.errorMsgRequiredField')),
    });
};
